import { Errors, useErrorNotificationApi } from '@equifinance/shared';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export enum DocumentType {
  PDF = 'PDF',
  JPEG = 'JPEG',
  PNG = 'PNG',
  EML = 'EML',
  DOCX = 'DOCX',
  XLSX = 'XLSX',
}

export enum TemplateCategory {
  Application = 'Application',
  Applicant1 = 'Applicant1',
  Applicant2 = 'Applicant2',
}

export type Template = {
  templateTypeId: string,
  category: TemplateCategory,
};

export type DocumentData = {
  id: string,
  uploadedDate: string,
  fileName: string,
  documentType: DocumentType,
  documentData: string,
}

export type DocumentTemplate = DocumentData & Template;

export type EsisInfo = {
  id: string,
  documentId: string,
  esisQuoteId: string,
  loanAmount: number,
  termInMonths: number,
  productType: string,
  initialRate: string,
  initialPayment: number,
  generatedTimeStamp: string,
  expiryDate: string,
  documentName: string,
}

export type Esis = {
  documentData: DocumentData,
  esisQuotes: EsisInfo[],
  errors: Errors,
};

export type CaseApiType = {
  getDocument: (applicationId: string, documentId: string) => Promise<DocumentData>,
  getEsisQuoteHistory: (applicationId: string) => Promise<EsisInfo[]>,
  postGenerateEsis: (applicationId: string, productId: string) => Promise<Esis>,
  postGenerateSummaryOfDisbursement: (applicationId: string) => Promise<DocumentData>,
  postDocumentTemplate: (applicationId: string, template: Template) => Promise<DocumentTemplate>,
}

const useDocumentsApi = (): CaseApiType => {
  const {
    get, post,
  } = useErrorNotificationApi(apiUrl);
  return {
    getDocument: (applicationId: string, documentId: string) => get(`documents/${applicationId}/${documentId}`),
    getEsisQuoteHistory: (applicationId: string) => get(`documents/esis-quote-history/${applicationId}`),
    postGenerateEsis: (applicationId: string, productId: string) => post('documents/generate-esis-quote', { applicationId, productId }),
    postGenerateSummaryOfDisbursement: (applicationId: string) => post(`documents/${applicationId}/generate-summary-of-disbursement`, {}),
    postDocumentTemplate: (applicationId: string, template: Template) => post(`documents/${applicationId}/template`, template),
  };
};

export default useDocumentsApi;
